import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_PAYMENT_SERVICE_V2_MIGRATION = defineFcm('payment_service_v2_migration')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				subscription_writes: { type: 'number', optional: true },
			},
		}),
	)
	.withDefault({})
	.toConfig({
		owner: 'squad-site-platform-payments',
		scope: 'corgi-middle-end',
		supportedGroups: { global: true },
		context: 'payment_service v1 to v2 migration',
		description:
			'Percentage (0-100) of calls sent to payment_service v2 instead of v1, per migration area. A record is in the rollout when its id modulo 100 is below the area value, so the same record always takes the same path. A missing key or 0 keeps that area on v1. subscription_writes: modifySubscription and cancelSubscription (PUT and DELETE /v2/subscriptions/{id}).',
		template: { subscription_writes: 0 },
	});
